import React from 'react';
import { Skeleton } from 'antd';

const SearchSkeleton = () => {
  const active = true;

  return (
    <React.Fragment>
      <div className='skeleton-margin'>
        <Skeleton.Input style={{ width: 230 }} active={active} />
      </div>
      <div className='skeleton-margin'>
        <Skeleton.Input style={{ width: 300 }} active={active} />
      </div>
      <div className='skeleton-margin'>
        <Skeleton.Input style={{ width: 320 }} active={active} />
      </div>
      <div className='skeleton-margin'>
        <Skeleton.Input style={{ width: 220, height: 100 }} active={active} />
      </div>
    </React.Fragment>
  )
}

export default SearchSkeleton;